import React from "react";
import ToolActionMenu from "./ToolActionMenu";
import ExcelColumn from "../../tool/ExcelColumn";
import TimePeriods from "./TimePeriods";
import GetAppIcon from "@mui/icons-material/GetApp";
import Tooltip from "@mui/material/Tooltip";
import CategoryMenu from "./CategoryMenu";

const ToolPanel = ({
  isFileUploadEnabled,
  isAction,
  handleApplyButton,
  handleCategoryChange,
  onGet,
  onFileChange,
  onUpload,
  ExcelSetup,
  onDowload,
  onAdd,
  onWorkAssign,
  onSwapCategory,
  onMessageSend,
  onBack,
}) => {
  return (
    <div className="container-fluid  mb-1 bg-muted">
      <div className="row">
        {/* File Upload UI */}
        <div
          className={`col-6 d-flex p-0 ${
            !isFileUploadEnabled ? "invisible" : ""
          }`}
        >
          <label
            htmlFor="file-upload"
            className="btn btn-outline-secondary rounded d-flex align-items-center"
            style={{
              cursor: "pointer",
              opacity: 1,
            }}
          >
            <i className="bi bi-upload me-2"></i>
            {isFileUploadEnabled ? "Upload File" : "File Upload Disabled"}
          </label>
          <input
            type="file"
            id="file-upload"
            className="d-none"
            disabled={!isFileUploadEnabled}
            accept=".xlsx, .xls"
            onChange={onFileChange}
          />
          {/* <button
            className="btn btn-outline-secondary d-flex align-items-center ms-1"
            onClick={onUpload}
            disabled={!isFileUploadEnabled}
            style={{
              cursor: "pointer",
            }}
          >
            Upload
          </button> */}
          <button
            className="btn btn-outline-secondary d-flex align-items-center ms-1"
            onClick={onGet}
            style={{
              cursor: "pointer",
            }}
          >
            <Tooltip title="Download Sample">
              <GetAppIcon />
            </Tooltip>
          </button>
        </div>

        {/* Action Menu */}
        <div className="col-6">
          <div className="d-flex justify-content-end align-items-center p-0 m-0">
            <div className="ms-lg-3 ms-md-2 ms-1">
              <Tooltip title="Select Category">
                <CategoryMenu handleCategoryChange={handleCategoryChange} />
              </Tooltip>
            </div>
            <div className="ms-lg-3 ms-md-2 ms-1">
              <Tooltip title="Select Time Period">
                <TimePeriods handleApplyButton={handleApplyButton} />
              </Tooltip>
            </div>
            <div className="ms-lg-3 ms-md-2 ms-1">
              <ExcelColumn
                selectedType={ExcelSetup.selectedType}
                selectedDates={ExcelSetup.selectedDates}
                excelKey={ExcelSetup.excelKey}
                category={ExcelSetup.category}
                excelColumns={ExcelSetup.excelColumns}
              />
            </div>

            {isAction && (
              <div className="ms-lg-3 ms-md-2 ms-1">
                <ToolActionMenu
                  onDownload={onDowload}
                  onSwapCategory={onSwapCategory}
                  onAdd={onAdd}
                  onMessageSend={onMessageSend}
                  onWorkAssign={onWorkAssign}
                  onBack={onBack}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolPanel;
